export default {
    restaurant: {
        fantasy_name: "",
        logo: "",
        delivery_prices: [{delivery_price: 0}]
    },
    categories: []
}